import { render, staticRenderFns } from "./UiSelect2.vue?vue&type=template&id=eab50420&"
import script from "./UiSelect2.vue?vue&type=script&lang=ts&"
export * from "./UiSelect2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports